import { HStack, Text } from "@chakra-ui/layout";
import { Skeleton, Tooltip } from "@chakra-ui/react";
import { NavBar } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";
import { useProjectNavigationPages } from "@src/components/widgets/AppSubNav/NavigationProject/hooks";
import { can } from "@src/utils/components/permissions";
import { useStore } from "@src/utils/hooks";
import { useScreenType } from "@src/utils/hooks/useIsMobile";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { AppSubNav } from "../AppSubNav";

type NavigationProjectsProps = {
  projectId?: string;
};

const NavigationProjects = ({ projectId }: NavigationProjectsProps) => {
  const { data, activePage, activeSubpage } =
    useProjectNavigationPages(projectId);
  const { isDesktop } = useScreenType();
  const { pathname } = useRouter();
  const { authStore } = useStore();
  const showPages =
    pathname === "/projects" || pathname === "/projects/planned-expenses";

  if (showPages) {
    return (
      <AppSubNav>
        <NavBar.Item href={{ pathname: "/projects" }}>
          <Trans>Projects</Trans>
        </NavBar.Item>
        {authStore.isInternalUser && (
          <NavBar.Item href={{ pathname: "/projects/planned-expenses" }}>
            <Trans>Planned expenses</Trans>
          </NavBar.Item>
        )}
      </AppSubNav>
    );
  }

  return (
    <AppSubNav>
      {can("project_read_all", "project_read_own", "project_read_team") && (
        <NavBar.Item href={{ pathname: "/projects" }} active={false}>
          <Trans>Projects</Trans>
        </NavBar.Item>
      )}

      {projectId && isDesktop && <Icon name="chevron-right" />}

      {projectId && (
        <NavBar.Item
          active={isDesktop ? false : undefined}
          href={{ pathname: "/projects/detail", query: { id: projectId } }}
        >
          <Skeleton minW="40px" isLoaded={!!data}>
            <HStack spacing="0" isTruncated>
              <Tooltip label={`${data?.title} (${data?.code})`}>
                <Text
                  isTruncated
                  fontSize="inherit"
                  fontWeight="inherit"
                  maxW={{
                    base: "full",
                    lg: "200px",
                    xl: "500px",
                  }}
                >
                  {data?.title}
                </Text>
              </Tooltip>
              <Text fontSize="inherit" fontWeight="inherit">
                &nbsp;({data?.code})
              </Text>
            </HStack>
          </Skeleton>
        </NavBar.Item>
      )}

      {activePage && isDesktop && <Icon name="chevron-right" />}

      {activePage && (
        <NavBar.Item active={false} href={activePage.href}>
          {activePage.title()}
        </NavBar.Item>
      )}

      {activePage && activeSubpage && isDesktop && (
        <Icon name="chevron-right" />
      )}

      {activePage && activeSubpage && (
        <NavBar.Item active={false} onClick={() => {}}>
          {activeSubpage.title()}
        </NavBar.Item>
      )}
    </AppSubNav>
  );
};

export default observer(NavigationProjects);
